export default "__VITE_ASSET__CC22HYJ3__"